// IMPORTANT: pinLayerOrder must run first — it inserts a <style> with the
// cascade-layer order at the front of <head> and keeps it there via a
// MutationObserver, so DS Button skins paint correctly over Tailwind preflight
// while Tailwind utilities can still override DS when applied. See the file
// for the full reasoning.
import '@/styles/pinLayerOrder';
import '@/styles/theme.css';

import type { IPicsartToolPubSub } from '@picsart/miniapps-sdk/types/types';
import { createRoot } from 'react-dom/client';

import App from './components/App';
import setupContext from './miniappContext';
import Wrappers from './Wrappers';

const setup = ({ containerId, pubsub }: { containerId: string; pubsub?: IPicsartToolPubSub }) => {
  const container = document.getElementById(containerId)!;
  const root = createRoot(container);
  setupContext({ pubsub });
  root.render(
    <Wrappers>
      <App />
    </Wrappers>,
  );
  return {
    unmount: () => root.unmount(),
  };
};

export default setup;
